// extracted by mini-css-extract-plugin
export default {"learning":"learning_learning__D7KU8","card":"learning_card__y52hR"};